import { useUiStore } from "~/stores/useUiStore";

export default defineNuxtRouteMiddleware((to, from) => {
  // Check if navigating to a project detail page from the projects list
  if (to.path.startsWith("/projects/") && from.path === "/projects") {
    // Capture current scroll position before navigation
    const scrollY = typeof window !== "undefined" ? window.scrollY : 0;

    // Save to global store
    const uiStore = useUiStore();
    uiStore.saveScrollPosition(scrollY);
  }
});
